import { styled, Grid, Typography, lighten } from "@mui/material";

export const TravelExpenseWrapper = styled(Grid)(({ theme }) => ({
  borderRadius: "0px",
  backgroundColor: theme.palette.background.default,
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)",
  WebkitPrintColorAdjust: "exact",
  WebkitFilter: "opacity(1)",
  border: `1px solid ${theme.palette.secondary.light}`,
}));

export const InfoContainer = styled(Grid)(({ theme }) => ({
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
}));

export const DetailsContainer = styled(Grid)({
  // padding : "20px",
  width: "100%",
});

export const Field = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
});

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.light,
}));

export const FieldValue = styled(Typography)(({ theme }) => ({}));

export const StatusCountryContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "auditAccepted",
})<{ auditAccepted: boolean | null }>(
  {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    gap: "5px",
  },
  ({ auditAccepted, theme }) => ({
    ...(auditAccepted === null && {
      backgroundColor: theme.palette.background.paper,
    }),
    ...(auditAccepted === true && {
      backgroundColor: lighten(theme.palette.success.main, 0.8),
    }),
    ...(auditAccepted === false && {
      backgroundColor: lighten(theme.palette.error.main, 0.9),
    }),
  })
);

export const Status = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "auditAccepted",
})<{ auditAccepted: boolean | null }>(({ auditAccepted, theme }) => ({
  ...(auditAccepted === null && {
    color: theme.palette.secondary.light,
  }),
  ...(auditAccepted === true && {
    color: theme.palette.success.main,
  }),
  ...(auditAccepted === false && {
    color: theme.palette.error.main,
  }),
}));
